module.exports = __webpack_public_path__ + "static/img/icon_wa.b4be7893.png";